import { popularCatalogItems } from '~/features/page-template/templates/home/model/recommendations';

import { CatalogCardRow, CatalogCardRowProps } from './catalog-card-row';

export type PersonalizedProgramRecommendationsProps = CatalogCardRowProps;
export function PersonalizedProgramRecommendations(props: PersonalizedProgramRecommendationsProps) {
  return <CatalogCardRow {...props} catalogItems={popularCatalogItems} />;
}
